import { UserEditModalForm } from "./UserEditModalForm";

const UserEditModalFormWrapper = ({
  selectedListingId,
  setSelectedListingId,
  openDeleteModal,
  setOpenDeleteModal,
  listing,
  getListing,
}) => {
  const itemIdForUpdate = null;
  const isLoading = false;

  if (selectedListingId) {
    return (
      <UserEditModalForm
        isUserLoading={isLoading}
        user={{ id: undefined }}
        setSelectedListingId={setSelectedListingId}
        selectedListingId={selectedListingId}
        listing={listing}
        getListing={getListing}
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
      />
    );
  }
  return null;
};

export { UserEditModalFormWrapper };
